import { render } from "./SearchAdvance.vue?vue&type=template&id=bbe0ede0"
import script from "./SearchAdvance.vue?vue&type=script&lang=js"
export * from "./SearchAdvance.vue?vue&type=script&lang=js"

import "./SearchAdvance.vue?vue&type=style&index=0&id=bbe0ede0&lang=css"

import exportComponent from "D:\\digitalnewspaper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__